module.exports = __webpack_public_path__ + "img/imperial.a716d389.png";